// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"63dc1ade","239":"ad40150f","453":"54292a4b","455":"6d6d8289","457":"ddb9b4c6","551":"eebf1ec6","641":"e08abf02","977":"83aac2ce"}[chunkId] + ".chunk.js";
};